export default __webpack_public_path__ + "static/media/drag-icon.aa95bd3f.svg";